module.exports = __webpack_public_path__ + "img/u7084.6e950f48.png";